import { useSelector } from 'react-redux';
import { selectUser } from '@store/usersSlice';

export function useAuth() {
  const user = useSelector(selectUser);
  return !!user;
}
